import { useQuery } from '@tanstack/react-query'
import {
  getGroupTermsWithAgreement,
  GroupTermsWithAgreementData,
  TermsHeimdallResponse,
} from '@tmap-web-lib/remote-api-client/frontman'
import { AxiosError } from 'axios'
import { KEYS } from '@/react-query'

interface Props {
  termsGroupCode: string;
  enabled?: boolean;
  useErrorBoundary?: boolean;
  excludeFromGlobalLoading?: boolean;
}

function useGetTermsGroupWithAgreement(props: Props) {
  const { termsGroupCode, enabled, useErrorBoundary, excludeFromGlobalLoading = false } = props
  return useQuery<TermsHeimdallResponse<GroupTermsWithAgreementData>, AxiosError>([KEYS.TERMS_GROUP_WITH_AGREEMENT(termsGroupCode)],
    () => getGroupTermsWithAgreement({ groupTermsId: termsGroupCode }).then(({ data }) => data),
    {
      enabled: enabled ?? true,
      useErrorBoundary: useErrorBoundary ?? true,
      meta: {
        excludeFromGlobalLoading: excludeFromGlobalLoading,
      },
    },
  )
}

export { useGetTermsGroupWithAgreement }
